export default __webpack_public_path__ + "static/media/playstore.489cf9b2.svg";